import { API_URL } from '@/api/url';
import { Http } from '@/lib/http';
import { DiscountRecordParams, DiscountRecordDetailParams } from '@/types/index.d';

class DiscountRecordApi {
  /**
   * 获取油站折扣调整记录
   * @link mock地址 https://mock.xiaojukeji.com/project/7211/interface/api/844103
   */
  static getDiscountRecords = (params: DiscountRecordParams) => {
    return Http({
      resLatest: API_URL.GetDiscountRecords,
      method: 'GET',
      url: API_URL.GetDiscountRecords,
      params
    });
  };

  /**
   * 获取油站折扣记录详情
   * @link mock地址 https://mock.xiaojukeji.com/project/7211/interface/api/844116
   */
  static getDiscountRecordDetail = (params: DiscountRecordDetailParams) => {
    return Http({
      method: 'GET',
      url: API_URL.GetDiscountRecordDetail,
      params
    });
  };
}

export default DiscountRecordApi;
